import React, { useState } from "react";
import Layout from "../../components/Layout";
import PageContainer from "../../components/common/PageContainer";
import PlatformSettingsPage from "./PlatformSettingsPage";

const BusinessAdminSettingsPage = () => {
  const [activeTab, setActiveTab] = useState("platform");

  return (
    <Layout>
      <PageContainer title="Platform Settings">
        <div className="mb-6 border-b border-gray-200">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            <button
              onClick={() => setActiveTab("platform")}
              className={`
                whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm
                ${activeTab === "platform"
                  ? "border-indigo-500 text-indigo-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }
              `}
            >
              Platform Settings
            </button>
            {/* You can add more tabs here in the future if needed */}
          </nav>
        </div>
        <div>
          {activeTab === "platform" && <PlatformSettingsPage noLayout />}
        </div>
      </PageContainer>
    </Layout>
  );
};

export default BusinessAdminSettingsPage;